module.exports = __webpack_public_path__ + "static/img/4f.5be77e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4f.jpg
// module id = Chv/
// module chunks = 1